var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33301 15.7501V17.4167C5.33301 17.8588 5.5086 18.2827 5.82116 18.5953C6.13372 18.9078 6.55765 19.0834 6.99967 19.0834H16.9997C17.4417 19.0834 17.8656 18.9078 18.1782 18.5953C18.4907 18.2827 18.6663 17.8588 18.6663 17.4167V15.7501M7.83301 9.08341L11.9997 4.91675M11.9997 4.91675L16.1663 9.08341M11.9997 4.91675V14.9167",
    stroke: "#808080",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.ef6a1c781f0b85ea207a64a4dd01cb00.svg";
export { ForwardRef as ReactComponent };